import { render, staticRenderFns } from "./JdsFieldRow.vue?vue&type=template&id=2ba515e6&scoped=true&"
import script from "./JdsFieldRow.vue?vue&type=script&lang=ts&"
export * from "./JdsFieldRow.vue?vue&type=script&lang=ts&"
import style0 from "./JdsFieldRow.vue?vue&type=style&index=0&id=2ba515e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba515e6",
  null
  
)

export default component.exports